module.exports = __webpack_public_path__ + "static/img/lamps-right.248da93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lamps-right.png
// module id = 166
// module chunks = 1